import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Note } from '../models/note.dto';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  constructor(private http: HttpClient) { }

  getNotes(uuid: string): Observable<Note[]> {
    return this.http.get<Note[]>(environment.beServiceUrl + '/v1/note/find?transitionUuid='+ uuid);
  }

  insertNote(request: any) {
    const url= environment.beServiceUrl + `/v1/note/insert`;
    return this.http.post<any>(url, request);
  }

  setRead(request: any) {
    const url= environment.beServiceUrl + `/v1/note/read`;
    return this.http.post<any>(url, request);
  }
}
